import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import API from "../axios";
import toast from "react-hot-toast";
import logo from "../assets/pos.png";
import "../style/login.css";

function ForgetPassword() {
  const navigate = useNavigate();

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [otpLoading, setOtpLoading] = useState(false);


  const [step, setStep] = useState(1);

  const [empcode, setEmpcode] = useState("");
  const [userData, setUserData] = useState(null);

  const [otpMethod, setOtpMethod] = useState("");
  const [otp, setOtp] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const cardAnimation = {
    initial: { opacity: 0, x: 60 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -60 },
    transition: { duration: 0.4 }
  };
  

  // STEP 1 → CHECK EMPLOYEE
  const checkEmployee = async () => {
    try {
      if (!empcode) {
        toast.error("Enter Employee Code");
        return;
      }

      const res = await API.post("/check-employee", {
        empcode
      });

      if (res.data.status === "success") {
        console.log(res.data.data);
        setUserData(res.data.data);
        toast.success("Employee Found");
        setStep(2);
      } else {
        toast.error("User Not Found");
      }
    } catch (err) {
      toast.error("Employee Not Found");
    }
  };

  // STEP 2 → SEND OTP
  const sendOtp = async (method) => {
    try {
        
          setOtpLoading(true);

      const mobile = userData.mobile_number;
      
      const mail = userData.company_email_id;

      const generatedOtp = Math.floor(
        1000 + Math.random() * 9000
      ).toString();

      const res = await API.post("/send-otp", {
        mobile,mail,
        otp: generatedOtp,
        otpMethod : method
      });

      if(res)

      if (res.data.status === "success") {
        localStorage.setItem("resetOtp", generatedOtp);

        toast.success(`OTP Sent via ${method}`);
        setStep(3);
      } else {
        toast.error("Failed to send OTP");
      }
    } catch (err) {
      toast.error("OTP Sending Failed");
    }
    finally {

    setOtpLoading(false);

  }
  };

//   const sendOtp = async (method) => {
//   try {

//     setOtpLoading(true);

//     const mobile = userData.mobile_number;
//     const mail = userData.company_email_id;

//     const generatedOtp = Math.floor(
//       1000 + Math.random() * 9000
//     ).toString();

//     const res = await API.post("/send-otp", {
//       mobile,
//       mail,
//       otp: generatedOtp,
//       otpMethod: method
//     });

//     // Success
//     if (res.data.status === "success") {

//       localStorage.setItem("resetOtp", generatedOtp);

//       toast.success(`OTP Sent via ${method}`);

//       setStep(3);

//     } else {

//       // Backend returned response but status is failed
//       toast.error(
//         res.data.message || "Failed to send OTP"
//       );

//     }

//   } catch (err) {

//     console.log("OTP ERROR:", err);

//     // Backend error message
//     const message =
//       err.response?.data?.message ||
//       err.message ||
//       "OTP Sending Failed";

//     toast.error(message);

//   } finally {

//     setOtpLoading(false);

//   }
// };

  // STEP 3 → VERIFY OTP
  const verifyOtp = () => {
    const savedOtp = localStorage.getItem("resetOtp");

    if (otp === savedOtp) {
      toast.success("OTP Verified");
      localStorage.removeItem("resetOtp");
      setStep(4);
    } else {
      toast.error("Invalid OTP");
    }
  };

  // STEP 4 → RESET PASSWORD
  const resetPassword = async () => {
    try {
      if (!newPassword || !confirmPassword) {
        toast.error("Fill all fields");
        return;
      }

      if (newPassword !== confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      const res = await API.post("/reset-password", {
        empcode,
        password: newPassword
      });

      if (res.data.status === "success") {
        toast.success("Password Updated");

        localStorage.removeItem("resetOtp");

        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        toast.error("Password Update Failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };


  const maskEmail = (email) => {
  if (!email) return "";

  const [name, domain] = email.split("@");

  if (name.length <= 5) {
    return (
      name.substring(0, 2) +
      "*".repeat(name.length - 2) +
      "@" +
      domain
    );
  }

  return (
    name.substring(0, 3) +
    "*".repeat(name.length - 5) +
    name.substring(name.length - 2) +
    "@" +
    domain
  );
};

  return (
    <div
      className="d-flex justify-content-center align-items-center p-3 p-lg-0 vh-100"
    //   style={{
    //     background:
    //       "linear-gradient(135deg,#0f172a,#1e293b,#334155)"
    //   }}
    >
      <div
        className="bg-white shadow-lg p-4 rounded-4 fpwdCard"
        style={{
          width: "100%",
          maxWidth: "420px",
          overflow: "hidden"
        }}
      >
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="logo"
            style={{ height: "70px" }}
          />

          <h4 className="fw-bold mt-3">

            {step !== 3 && step !== 4 ?  "Forgot Password" : ""}
          
          </h4>
        </div>

        <AnimatePresence mode="wait">

          {/* STEP 1 */}
          {step === 1 && (
            <motion.div
            className="fpwdsize"
              key="step1"
              {...cardAnimation}
            >
              <label className="fw-bold mb-2">
                Employee Code
              </label>

              <input
                type="text"
                className="form-control mb-3 fpwdsize"
                placeholder="Enter Employee Code"
                value={empcode}
                onChange={(e) =>
                  setEmpcode(e.target.value)
                }
              />

              <button
                className="btn btn-primary w-100 fw-bold fpwdsize"
                onClick={checkEmployee}
              >
                Continue
              </button>
            </motion.div>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <motion.div
              key="step2"
              {...cardAnimation}
            >
              <h6 className="fw-bold mb-3 text-center fpwdsize">
                Send OTP Via
              </h6>

              {userData?.company_email_id && (
                <div className="alert alert-light border text-center mb-3">
                  {/* <i className="bi bi-envelope-fill text-primary me-2"></i>
                  OTP will be sent to
                  <br /> */}
                  <strong>{maskEmail(userData.company_email_id)}</strong>
                </div>
              )}

              <div className="d-grid gap-3">

                {userData?.company_email_id && (
                  <button
                    className="btn btn-outline-primary fpwdsize"
                    onClick={() => sendOtp("email")}
                    disabled={otpLoading}
                  >

                    {otpLoading ? (
                            <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Sending...
                            </>
                        ) : (
                            <>
                            <i className="bi bi-envelope-at-fill me-1"></i>
                            Send to Email
                            </>
                        )}

                    {/* <i class="bi bi-envelope-at-fill me-1"></i> Send to Email */}
                  </button>
                )}

                {/* {userData?.mobile_number && (
                  <button
                    className="btn btn-outline-success"
                    onClick={() => sendOtp("whatsapp")}
                    disabled={otpLoading}
                  >
                     {otpLoading ? (
                            <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Sending...
                            </>
                        ) : (
                            <>
                            <i className="bi bi-whatsapp me-2"></i>
                            Send to WhatsApp
                            </>
                        )}

                  </button>
                )} */}
                
                    {/* <i class="bi bi-whatsapp me-2"></i>Send to WhatsApp */}

              </div>
            </motion.div>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <motion.div
              key="step3"
              {...cardAnimation}
            >
              <h6 className="text-center mb-3 fw-bold fpwdsize">
                Enter OTP
              </h6>

              <input
                type="text"
                className="form-control mb-3 text-center fpwdsize"
                placeholder="4 Digit OTP"
                maxLength={4}
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value)
                }
              />

              <button
                className="btn btn-success w-100 fw-bold fpwdsize"
                onClick={verifyOtp}
              >
                Verify OTP
              </button>
            </motion.div>
          )}

          {/* STEP 4 */}
          {/* {step === 4 && (
            <motion.div
              key="step4"
              {...cardAnimation}
            >
              <h6 className="text-center fw-bold mb-3">
                Create New Password
              </h6>

              <input
                type="password"
                className="form-control mb-3"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(e.target.value)
                }
              />

              <input
                type="password"
                className="form-control mb-3"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value)
                }
              />

              <button
                className="btn btn-dark w-100 fw-bold"
                onClick={resetPassword}
              >
                Update Password
              </button>
            </motion.div>
          )} */}


            {step === 4 && (
            <motion.div
                key="step4"
                {...cardAnimation}
            >
                <h6 className="text-center fw-bold mb-3 ">
                Create New Password
                </h6>

                {/* NEW PASSWORD */}
                <div className="position-relative mb-3">

                <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control pe-5 fpwdsize newpass"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) =>
                    setNewPassword(e.target.value)
                    }
                />

                <i
                    className={`bi fpwdeye ${
                    showNewPassword
                        ? "bi-eye-slash"
                        : "bi-eye"
                    } position-absolute`}
                    style={{
                    right: "15px",
                    top: "10px",
                    cursor: "pointer",
                    fontSize: "18px"
                    }}
                    onClick={() =>
                    setShowNewPassword(!showNewPassword)
                    }
                ></i>

                </div>

                {/* CONFIRM PASSWORD */}
                <div className="position-relative mb-3">

                <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control pe-5 fpwdsize newpass"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) =>
                    setConfirmPassword(e.target.value)
                    }
                />

                <i
                    className={`bi fpwdeye ${
                    showConfirmPassword
                        ? "bi-eye-slash"
                        : "bi-eye"
                    } position-absolute`}
                    style={{
                    right: "15px",
                    top: "10px",
                    cursor: "pointer",
                    fontSize: "18px"
                    }}
                    onClick={() =>
                    setShowConfirmPassword(
                        !showConfirmPassword
                    )
                    }
                ></i>

                </div>

                <button
                className="btn btn-dark w-100 fw-bold fpwdsize"
                onClick={resetPassword}
                >
                Update Password
                </button>
            </motion.div>
            )}

        </AnimatePresence>

        <div className="text-center mt-4">
          <span
            className="text-primary fw-bold fpwdsize"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Back to Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;